export default __webpack_public_path__ + "static/media/select_icon.40cd1b7b.svg";